import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useStores } from 'src/common/stores/use-stores';
import { LineSkeletonType } from '@shared-ui/lodging-property-listing';
import { useLodgingURLParamsToQueryInputs } from '@shared-ui/retail-search-tools-lodging';
import { getSharedUIListingsInputsWithSearchId, hasSearchCriteriaChanged } from 'stores/adapters';
import { ResultsSubHeaderWrapper } from './results-sub-header-wrapper';
export const SplitViewResultsSubHeaderWrapper = () => {
  const {
    context,
    experiment,
    pageLayout,
    searchCriteria,
    searchResults,
    analyticsSearch
  } = useStores();
  const listingsQueryInputs = useLodgingURLParamsToQueryInputs();
  const location = useLocation();
  if (!context || !searchCriteria || !searchResults || !analyticsSearch) {
    return null;
  }
  const searchInputs = listingsQueryInputs ? getSharedUIListingsInputsWithSearchId(listingsQueryInputs, context, analyticsSearch, location, pageLayout, searchCriteria, experiment) : undefined;
  const criteriaChanged = hasSearchCriteriaChanged(context, searchCriteria, searchResults);
  return React.createElement(ResultsSubHeaderWrapper, {
    analyticsSearch: analyticsSearch,
    searchInputs: searchInputs,
    searchResults: searchResults,
    criteriaChanged: criteriaChanged,
    skeletonLayout: [LineSkeletonType.Secondary]
  });
};
SplitViewResultsSubHeaderWrapper.displayName = 'ResultsSubHeader';